export function textAligner(style) {
  const styleLowerCase = style ? style.toLowerCase() : ''
  if (styleLowerCase === 'right') {
    return 'text-right align-right'
  }
  if (styleLowerCase === 'center') {
    return 'text-center align-center'
  }

  return 'text-left align-left'
}

export function boxAligner(style) {
  const styleLowerCase = style ? style.toLowerCase() : ''
  if (styleLowerCase === 'right') {
    return 'box-rigth'
  }
  if (styleLowerCase === 'center') {
    return 'box-center'
  }

  return 'box-left'
}
